import { Document } from "../models";

export const isValidForDocumentPreview = (document: Document): boolean => document.fileType === "jpeg" || document.fileType === "jpg" || document.fileType === "pdf" || document.fileType === "png" || document.fileType === "txt";